// extracted by mini-css-extract-plugin
export default {"subContainer":"sub_subContainer__ezmEd","contactLOGO":"sub_contactLOGO__gxVRN","footerForm":"sub_footerForm__g50Zt","btn":"sub_btn__lHEEd"};